import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePresentationEdit } from '@/module/Author/Presentation/model/PresentationQuery';
import {
  PresentationSchema,
  defaultPresentationValues,
  presentationSchema,
} from '@/module/Author/Presentation/model/PresentationSchema';

import { useAppNotification } from '@feature/utils';

import { PresentationForm } from './PresentationForm';
import { Presentation } from './model/PresentationTypes';

interface PresentationEditProps {
  presentation: Presentation;
}

const convert = (presentation: Presentation): PresentationSchema => ({
  ...presentation,
});

export function PresentationEdit(props: PresentationEditProps) {
  const { presentation } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePresentationEdit(presentation.id);

  const notification = useAppNotification();
  const onSubmit = (values: PresentationSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(presentation), [presentation]);
  const navigate = useNavigate();

  return (
    <PresentationForm
      title={t('presentations.form.title.edit')}
      schema={presentationSchema}
      defaultValues={defaultPresentationValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
